import { render } from "./LineasFacturacionPage.vue?vue&type=template&id=47620912&scoped=true"
import script from "./LineasFacturacionPage.vue?vue&type=script&lang=js"
export * from "./LineasFacturacionPage.vue?vue&type=script&lang=js"

import "./LineasFacturacionPage.vue?vue&type=style&index=0&id=47620912&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47620912"]])

export default __exports__